"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const lodash_1 = require("lodash");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_components_1 = require("@apollo/react-components");
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const context_1 = require("../../context");
const reusables_1 = require("../../comps/reusables");
const PreviewModal_1 = require("../../comps/reusables/PreviewModal");
const svg_1 = require("../../svg");
const graphql_1 = require("../../graphql");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const react_hanger_1 = require("react-hanger");
const react_2 = require("@osmosys/react");
exports.WorkflowRunDetail = ({ data, showWorkflow }) => {
    const { state, setState } = react_hanger_1.useSetState({
        showDetails: false,
        showDetailsMount: false,
        showPreviewHTML: false,
    });
    const { history } = use_react_router_1.default();
    const { status, runDateTime, id, workflow, edited, failureReason, proofSendDateTime, } = data;
    const momentRunDateTime = moment_1.default(runDateTime);
    const momentProofSendDateTime = moment_1.default(proofSendDateTime);
    const renderEmailBuilderPreview = (contents, emailNumber) => {
        return (react_1.default.createElement(react_components_1.Query, { query: graphql_1.email(false), variables: {
                emailNumber: emailNumber ? parseInt(`${emailNumber}`, 10) : undefined,
            } }, queryResult => (react_1.default.createElement(react_1.default.Fragment, null,
            contents,
            queryResult.data && queryResult.data.email && (react_1.default.createElement(PreviewModal_1.PreviewModal, { isOpen: state.showPreviewHTML, onClose: () => setState({
                    showPreviewHTML: false,
                }), html: queryResult.data.email.html }))))));
    };
    let LogoComponent;
    let opacity = 1;
    let classNames = 'bg-light text-muted-dark';
    let dateStr;
    let dateIcon = pro_solid_svg_icons_1.faClock;
    // let btnText = 'Edit';
    if (status === 'succeeded') {
        dateStr = 'Successfully sent';
        if (data.ranByUser) {
            dateStr = (react_1.default.createElement(react_1.default.Fragment, null,
                dateStr,
                " by",
                ' ',
                react_1.default.createElement(react_2.OsmosysTooltip, { label: data.ranByUser.email, off: !data.ranByUser.fullName },
                    react_1.default.createElement("span", { id: `workflow-run-detail-${id}-ran-by-user`, className: "text-underline" }, data.ranByUser.fullName || data.ranByUser.email))));
        }
        dateIcon = pro_solid_svg_icons_1.faCheckCircle;
        LogoComponent = svg_1.WorkflowsSuccess;
        classNames = 'bg-success-light text-success-dark';
        // btnText = 'Details';
    }
    else if (status === 'failed') {
        dateStr = 'Failed';
        dateIcon = pro_solid_svg_icons_1.faExclamationCircle;
        LogoComponent = svg_1.WorkflowsFailure;
        classNames = 'bg-danger-light text-danger-dark';
    }
    else if (status === 'scheduled') {
        dateStr = `Scheduled to run  ${momentRunDateTime.fromNow()}`;
        if (workflow.nextWorkflowRun && workflow.nextWorkflowRun.id === id) {
            dateStr = (react_1.default.createElement(react_1.default.Fragment, null,
                dateStr,
                "\u00B7",
                react_1.default.createElement(react_components_1.Mutation, { mutation: graphql_1.runWorkflowRun, variables: {
                        id,
                    } }, (mutate, runResult) => (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("a", { href: "#", onClick: e => {
                            e.preventDefault();
                            mutate();
                        } }, runResult.loading ? 'Running...' : 'Run now'),
                    react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "WorkflowRun", action: "update", apolloError: runResult.error }))))));
        }
        LogoComponent = svg_1.WorkflowsScheduled;
        classNames = 'bg-light text-muted-dark';
    }
    else if (status === 'cancelled') {
        dateStr = 'Cancelled';
        LogoComponent = svg_1.WorkflowsCancelled;
        classNames = 'bg-warning-light text-warning-dark';
    }
    else if (status === 'paused') {
        dateIcon = pro_solid_svg_icons_1.faPause;
        dateStr = (react_1.default.createElement(react_1.default.Fragment, null,
            "Paused \u00B7",
            ' ',
            react_1.default.createElement(react_components_1.Mutation, { mutation: graphql_1.pauseWorkflowRun, variables: {
                    id,
                    paused: false,
                } }, (mutate, pauseResult) => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("a", { href: "#", onClick: e => {
                        e.preventDefault();
                        mutate();
                    } }, pauseResult.loading ? 'Unpausing...' : 'Unpause'),
                react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "WorkflowRun", action: "update", apolloError: pauseResult.error }))))));
        LogoComponent = svg_1.WorkflowsPaused;
        classNames = 'bg-warning-light text-warning-dark';
    }
    else if (status === 'proofSentNoApprovalNeeded') {
        dateStr = react_1.default.createElement(react_1.default.Fragment, null,
            "Proof sent ",
            momentProofSendDateTime.fromNow());
        LogoComponent = svg_1.WorkflowsScheduled;
        classNames = 'bg-light text-primary-dark';
        dateIcon = pro_solid_svg_icons_1.faPaperPlane;
    }
    else if (status === 'pendingApproval') {
        dateStr = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("strong", null, "Waiting for approval."),
            " Proof sent",
            ' ',
            momentProofSendDateTime.fromNow(),
            "."));
        LogoComponent = svg_1.WorkflowsScheduled;
        classNames = 'bg-light text-primary-dark';
        dateIcon = pro_solid_svg_icons_1.faPaperPlane;
    }
    else {
        LogoComponent = svg_1.WorkflowsLogo;
        opacity = 0.5;
    }
    if (workflow.archived) {
        opacity = 0.4;
    }
    return (react_1.default.createElement(react_components_1.Query, { query: graphql_1.workflowRunExpanded, 
        // skip={!state.showDetails}
        variables: { id } }, expandedDetailQuery => {
        const workflowMeta = expandedDetailQuery.data &&
            expandedDetailQuery.data.workflowRun &&
            expandedDetailQuery.data.workflowRun.workflowMeta;
        const btnGroup = (padBtnRight = false) => (react_1.default.createElement(react_1.default.Fragment, null,
            status === 'scheduled' && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_2.OsmosysTooltip, { label: "Edit email" },
                    react_1.default.createElement(reactstrap_1.Button, { size: "sm", color: "dark", className: classnames_1.default('mb-1', { 'mr-1': padBtnRight }), disabled: !(workflowMeta && workflowMeta.email), id: `workflow-run-${id}-btn-edit-email`, onClick: () => {
                            if (workflowMeta && workflowMeta.email) {
                                history.push(`/emails/${expandedDetailQuery.data.workflowRun.workflowMeta.email.emailNumber}`);
                            }
                        } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPencilAlt, className: "mr-1" }),
                        "Edit")))),
            react_1.default.createElement(reactstrap_1.ButtonGroup, null,
                status === 'scheduled' && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_components_1.Mutation, { mutation: graphql_1.pauseWorkflowRun, variables: {
                            id,
                        } }, (mutate, pauseResult) => (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_2.OsmosysTooltip, { label: "Pause workflow run" },
                            react_1.default.createElement(reactstrap_1.Button, { size: "sm", color: "light", onClick: () => {
                                    mutate();
                                }, id: `workflow-run-${id}-btn-pause`, disabled: pauseResult.loading },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { spin: pauseResult.loading, icon: pauseResult.loading
                                        ? pro_solid_svg_icons_1.faSpinnerThird
                                        : pauseResult.error
                                            ? pro_solid_svg_icons_1.faExclamationTriangle
                                            : pauseResult.data
                                                ? pro_solid_svg_icons_1.faCheck
                                                : pro_solid_svg_icons_1.faPause }))),
                        react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "WorkflowRunAction", action: "update", apolloError: pauseResult.error })))))),
                workflowMeta &&
                    workflowMeta.email &&
                    renderEmailBuilderPreview(react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_2.OsmosysTooltip, { label: "Preview email" },
                            react_1.default.createElement(reactstrap_1.Button, { size: "sm", color: "light", id: `workflow-run-${id}-btn-preview`, className: "ml-auto", onClick: () => {
                                    setState({
                                        showPreviewHTML: true,
                                    });
                                } },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faEye })))), workflowMeta.email.emailNumber),
                react_1.default.createElement(react_2.OsmosysTooltip, { label: state.showDetails ? 'Collapse' : 'Expand' },
                    react_1.default.createElement(reactstrap_1.Button, { size: "sm", color: "light", onClick: () => {
                            setState({
                                showDetails: !state.showDetails,
                                showDetailsMount: !state.showDetails,
                            });
                        }, id: `workflow-run-${id}-btn-expand` },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { spin: state.showDetails && expandedDetailQuery.loading, icon: state.showDetails
                                ? expandedDetailQuery.loading
                                    ? pro_solid_svg_icons_1.faSpinnerThird
                                    : pro_solid_svg_icons_1.faChevronUp
                                : pro_solid_svg_icons_1.faChevronDown }))))));
        return (react_1.default.createElement(react_1.default.Fragment, null,
            showWorkflow && (react_1.default.createElement(reactstrap_1.Row, { className: "p-0 m-0 border-bottom" },
                react_1.default.createElement(reactstrap_1.Col, { className: "py-1 px-2 m-0" },
                    react_1.default.createElement("p", { className: "mb-0" },
                        react_1.default.createElement("span", { className: "text-muted" }, "Workflow:"),
                        ' ',
                        workflow.archived && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArchive, className: "mr-2" })),
                        react_1.default.createElement(react_router_dom_1.Link, { className: classnames_1.default({
                                'text-muted': workflow.archived,
                            }), to: `/workflows/${workflow.id}` }, workflow.name),
                        workflow.archived && ' (archived - will not run)')))),
            react_1.default.createElement(reactstrap_1.Row, { className: "p-0 m-0" },
                react_1.default.createElement(react_2.OsmosysTooltip, { label: lodash_1.capitalize(status) },
                    react_1.default.createElement(reactstrap_1.Col, { id: `workflow-detail-icon-${id}`, className: classnames_1.default('flex-grow-0 py-3 px-3 justify-content-center d-flex flex-column', classNames), alt: status, title: status, style: { opacity } },
                        react_1.default.createElement(LogoComponent, { width: "70", height: "70" }))),
                react_1.default.createElement(reactstrap_1.Col, { className: "p-3 flex-col-centered" },
                    react_1.default.createElement("div", null,
                        status !== 'failed' && (react_1.default.createElement("div", null,
                            workflowMeta && !workflowMeta.email && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(reactstrap_1.Badge, { color: "warning", className: "mr-1" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faExclamationCircle, className: "mr-1 text-dark" }),
                                    "An email is needed"))),
                            edited && react_1.default.createElement(reactstrap_1.Badge, { color: "success" }, "Edited"))),
                        react_1.default.createElement("h5", null, momentRunDateTime.format('LLLL')),
                        react_1.default.createElement("p", { className: "mb-0 lead" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: dateIcon, className: "mr-2" }),
                            dateStr),
                        react_1.default.createElement(reactstrap_1.Collapse, { delay: { hide: 0, show: 100 }, isOpen: !!(!expandedDetailQuery.loading &&
                                workflowMeta &&
                                workflowMeta.sendProof) },
                            react_1.default.createElement(context_1.OsmosysAppContext.Consumer, null, ({ currentUser }) => (react_1.default.createElement(react_1.default.Fragment, null,
                                expandedDetailQuery.data &&
                                    expandedDetailQuery.data.workflowRun &&
                                    expandedDetailQuery.data.workflowRun.workflowMeta &&
                                    expandedDetailQuery.data.workflowRun.workflowMeta
                                        .minutesBeforeRunToSendProof && (react_1.default.createElement("p", { className: "mt-2 mb-0 text-secondary" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheckDouble, className: "mr-2" }),
                                    `Proof will be sent ${expandedDetailQuery.data.workflowRun
                                        .workflowMeta.minutesBeforeRunToSendProof} minutes before at ${moment_1.default(momentRunDateTime)
                                        .subtract(expandedDetailQuery.data.workflowRun
                                        .workflowMeta.minutesBeforeRunToSendProof, 'minutes')
                                        .format('LT')}`,
                                    ' ',
                                    "to",
                                    ' ',
                                    react_1.default.createElement(react_2.OsmosysTooltip, { label: expandedDetailQuery.data &&
                                            expandedDetailQuery.data.workflowRun.workflowMeta.usersToSendProofsTo
                                                .map(user => user.email)
                                                .join(', ') },
                                        react_1.default.createElement("span", { id: `workflow-run-${id}-proof-user-tooltip`, className: "text-underline" }, expandedDetailQuery.data.workflowRun
                                            .workflowMeta.usersToSendProofsTo
                                            .length === 1 ? (react_1.default.createElement(react_1.default.Fragment, null, currentUser.id ===
                                            expandedDetailQuery.data.workflowRun
                                                .workflowMeta.usersToSendProofsTo[0]
                                                .id ? (react_1.default.createElement(react_router_dom_1.Link, { className: "text-secondary", to: "/profile" }, "you")) : (expandedDetailQuery.data.workflowRun
                                            .workflowMeta.usersToSendProofsTo[0]
                                            .fullName))) : (react_1.default.createElement(react_1.default.Fragment, null,
                                            expandedDetailQuery.data.workflowRun
                                                .workflowMeta.usersToSendProofsTo
                                                .length,
                                            ' ',
                                            "users")))),
                                    ".")),
                                expandedDetailQuery.data &&
                                    expandedDetailQuery.data.workflowRun &&
                                    expandedDetailQuery.data.workflowRun.workflowMeta &&
                                    expandedDetailQuery.data.workflowRun.workflowMeta
                                        .requireApproval && (react_1.default.createElement("p", { className: "mt-2 mb-0 text-secondary" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheckDouble, className: "mr-2", style: { opacity: 0 } }),
                                    "Approval is required by",
                                    ' ',
                                    react_1.default.createElement(react_2.OsmosysTooltip, { label: expandedDetailQuery.data.workflowRun.workflowMeta.usersThatCanApprove
                                            .map(user => user.email)
                                            .join(', ') },
                                        react_1.default.createElement("span", { id: `workflow-run-${id}-approval-user-tooltip`, className: "text-underline" }, expandedDetailQuery.data.workflowRun
                                            .workflowMeta.usersThatCanApprove
                                            .length === 1 ? (react_1.default.createElement(react_1.default.Fragment, null, currentUser.id ===
                                            expandedDetailQuery.data.workflowRun
                                                .workflowMeta.usersThatCanApprove[0]
                                                .id ? (react_1.default.createElement(react_router_dom_1.Link, { className: "text-secondary", to: "/profile" }, "you")) : (expandedDetailQuery.data.workflowRun
                                            .workflowMeta.usersToSendProofsTo[0]
                                            .fullName))) : (react_1.default.createElement(react_1.default.Fragment, null,
                                            "one of",
                                            ' ',
                                            expandedDetailQuery.data.workflowRun
                                                .workflowMeta.usersThatCanApprove
                                                .length,
                                            ' ',
                                            "users"))),
                                        "."))))))),
                        failureReason && (react_1.default.createElement(reactstrap_1.Alert, { color: "danger", className: "mb-0 mt-3" },
                            react_1.default.createElement("strong", null, "Reason for workflow run failure: "),
                            failureReason))),
                    react_1.default.createElement("div", { className: "d-block mt-2 w-100 d-lg-none" }, btnGroup(true))),
                react_1.default.createElement(reactstrap_1.Col, { className: "flex-grow-0 d-none d-lg-flex justify-content-center flex-column" }, btnGroup(false))),
            react_1.default.createElement(reactstrap_1.Collapse, { onExited: () => {
                    setState({
                        showDetailsMount: false,
                    });
                }, isOpen: state.showDetails &&
                    !expandedDetailQuery.loading &&
                    !!expandedDetailQuery.data }, state.showDetailsMount &&
                !expandedDetailQuery.loading &&
                !!expandedDetailQuery.data && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("hr", { className: "m-0" }),
                react_1.default.createElement(reactstrap_1.Row, { className: "p-3" },
                    react_1.default.createElement(reactstrap_1.Col, null,
                        react_1.default.createElement("h5", null, "Run Details"),
                        status !== 'succeeded' && (react_1.default.createElement(reusables_1.Form, { mutationProps: {
                                mutation: graphql_1.updateWorkflowRun,
                                onCompleted: () => {
                                    // TODO: not working
                                    setState({
                                        showDetails: false,
                                        showDetailsMount: false,
                                    });
                                },
                            }, valuesToVariables: values => {
                                return {
                                    data: {
                                        runDateTime: moment_1.default(values.runDateTime)
                                            .utc()
                                            .format(),
                                        workflowMeta: {
                                            emailId: values.email
                                                ? values.email.id
                                                : null,
                                        },
                                    },
                                    id,
                                };
                            }, formikProps: {
                                initialValues: {
                                    email: workflowMeta && workflowMeta.email
                                        ? workflowMeta.email
                                        : null,
                                    runDateTime: moment_1.default(momentRunDateTime),
                                },
                            } }, (formikProps, mutationResult) => {
                            return (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(reusables_1.FormGroup, { label: "Time", name: "runDateTime", type: "datetime" }),
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement(reusables_1.AjaxButton, { label: "Save", type: "submit", error: mutationResult.error, loading: mutationResult.loading, success: !!mutationResult.data }),
                                    edited && (react_1.default.createElement(react_components_1.Mutation, { mutation: graphql_1.revertWorkflowRunChanges, variables: {
                                            id,
                                        }, onCompleted: () => {
                                            // TODO: not working
                                            setState({
                                                showDetails: false,
                                                showDetailsMount: false,
                                            });
                                        } }, (revert, revertResult) => {
                                        return (react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement(reusables_1.AjaxButton, { type: "button", label: "Revert edit", className: "ml-auto", success: !!revertResult.data, error: revertResult.error, loading: revertResult.loading, onClick: () => {
                                                    revert();
                                                }, color: "link" }),
                                            react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "WorkflowRun", action: "update", apolloError: revertResult.error })));
                                    }))),
                                react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "WorkflowRun", action: "update", apolloError: mutationResult.error })));
                        })))))))));
    }));
};
//# sourceMappingURL=WorkflowRunDetail.js.map